import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import formatCurrency from '../../../lib/formatCurrency';
import {
  StockBadge,
  PriceDisplay,
  Price,
  ActionRow,
  QuantityControl,
  QuantityButton,
  QuantityDisplay,
  AddToCartButton,
  InquiryButton,
  DetailsButton,
  CompareButton,
  LoadingSpinner,
} from './PriceActions.style';

const PriceActions = ({
  tyre,
  quantity,
  onIncrement,
  onDecrement,
  onAddToCart,
  isAddingToCart,
  onInquiry,
  onDetails,
  isInComparison,
  onToggleCompare,
  isComparisonFull,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {tyre.quantity !== undefined && (
        <StockBadge stockLevel={tyre.quantity}>
          {tyre.quantity > 0
            ? t('inStockCount', { count: tyre.quantity > 4 ? '4+' : tyre.quantity })
            : t('notInStock')}
        </StockBadge>
      )}

      <PriceDisplay>
        <Price>
          {tyre.grossPrice ? formatCurrency(tyre.grossPrice) : '---'}
        </Price>
      </PriceDisplay>

      <ActionRow>
        <QuantityControl>
          <QuantityButton onClick={onDecrement}>−</QuantityButton>
          <QuantityDisplay>{quantity}</QuantityDisplay>
          <QuantityButton onClick={onIncrement}>+</QuantityButton>
        </QuantityControl>

        <CompareButton
          onClick={() => onToggleCompare(tyre)}
          isInComparison={isInComparison}
          disabled={!isInComparison && isComparisonFull}
          title={
            isInComparison
              ? t('removeFromComparison')
              : isComparisonFull
              ? t('comparisonFull')
              : t('addToComparison')
          }
        >
          <i className={isInComparison ? 'mdi mdi-check' : 'mdi mdi-scale-balance'} />
        </CompareButton>

        <InquiryButton onClick={onInquiry} title={t('inquiry')}>
          <i className="mdi mdi-email-outline" />
        </InquiryButton>

        <DetailsButton onClick={onDetails} title={t('details')}>
          <i className="mdi mdi-information-variant" />
        </DetailsButton>
      </ActionRow>

      <AddToCartButton onClick={() => onAddToCart(tyre._id)} disabled={isAddingToCart}>
        {isAddingToCart ? (
          <>
            <LoadingSpinner />
            <span>{t('adding')}</span>
          </>
        ) : (
          <>
            <i className="mdi mdi-cart-outline" />
            <span>{t('addToCart')}</span>
          </>
        )}
      </AddToCartButton>
    </>
  );
};

PriceActions.propTypes = {
  tyre: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    quantity: PropTypes.number,
    grossPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  quantity: PropTypes.number.isRequired,
  onIncrement: PropTypes.func.isRequired,
  onDecrement: PropTypes.func.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  isAddingToCart: PropTypes.bool,
  onInquiry: PropTypes.func.isRequired,
  onDetails: PropTypes.func.isRequired,
  isInComparison: PropTypes.bool,
  onToggleCompare: PropTypes.func.isRequired,
  isComparisonFull: PropTypes.bool,
};

export default PriceActions;
